import React, { Component } from "react";
import "./PrivacyPage.scss";

interface PrivacyPageProps {}

interface PrivacyPageState {}

class PrivacyPage extends Component<PrivacyPageProps, PrivacyPageState> {
  constructor(props: PrivacyPageProps) {
    super(props);
    this.state = {};
  }

  render(): React.JSX.Element {
    return (
      <div className="privacy-page">
        <div className="privacy-container">
          <div className="privacy-content">
            <h1 className="privacy-content-title">Privacy Policy</h1>

            <p>
              <strong>Effective Date:</strong> 5 Apr, 2026
            </p>
            <p>
              <strong>Last Updated:</strong> 9 Apr, 2026
            </p>

            <p>
              Welcome to <strong>EmailAjent.com</strong> (&quot;we&quot;, &quot;our&quot;, or
              &quot;us&quot;). Your privacy is important to us. This Privacy Policy explains how we
              collect, use, and protect your personal information when you use our service.
            </p>

            <hr className="privacy-divider" />

            <h2 className="privacy-section-title">1. Information We Collect</h2>

            <p>When you use EmailAjent, we may collect the following types of personal information:</p>

            <ul className="privacy-list">
              <li>
                <strong>Name</strong>
              </li>
              <li>
                <strong>Email address</strong>
              </li>
              <li>
                <strong>Google Calendar data</strong> (such as event titles, times, descriptions, and
                associated metadata)
              </li>
            </ul>

            <p>
              This information is collected when you authenticate and connect your Google Calendar
              account.
            </p>

            <hr className="privacy-divider" />

            <h2 className="privacy-section-title">2. How We Use Your Information</h2>

            <p>We use your information strictly to:</p>

            <ul className="privacy-list">
              <li>Provide and operate the EmailAjent service</li>
              <li>Manage your calendar via Google Calendar API</li>
              <li>Respond to your commands and queries related to your calendar</li>
            </ul>

            <p>
              We <strong>do not</strong> use your data for advertising or share it with third parties
              for marketing purposes.
            </p>

            <hr className="privacy-divider" />

            <h2 className="privacy-section-title">3. Data Storage and Security</h2>

            <p>
              All collected information is stored securely on our servers. We implement
              industry-standard security measures to protect your personal data from unauthorized
              access, disclosure, or destruction.
            </p>

            <p>
              However, no method of transmission over the Internet or method of electronic storage is
              100% secure. Therefore, while we strive to use commercially acceptable means to protect
              your data, we cannot guarantee its absolute security.
            </p>

            <hr className="privacy-divider" />

            <h2 className="privacy-section-title">4. Google API Disclosure</h2>

            <p>
              EmailAjent&apos;s use of information received from Google APIs adheres to the{" "}
              <a
                className="privacy-link"
                href="https://developers.google.com/terms/api-services-user-data-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google API Services User Data Policy
              </a>
              , including the Limited Use requirements.
            </p>

            <hr className="privacy-divider" />

            <h2 className="privacy-section-title">5. OpenAI API Disclosure</h2>

            <p>
              EmailAjent uses the OpenAI API to help process and manage service-related data and
              requests.
            </p>

            <p>
              In addition to this Privacy Policy, OpenAI&apos;s Privacy Policy may also apply to data
              processed through these services. You can review it here:{" "}
              <a
                className="privacy-link"
                href="https://openai.com/en-GB/policies/row-privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                OpenAI Privacy Policy
              </a>
              .
            </p>

            <hr className="privacy-divider" />

            <h2 className="privacy-section-title">6. Data Retention</h2>

            <p>
              We retain your personal data for as long as necessary to provide our services, or until
              you request deletion. If you disconnect your Google account or stop using EmailAjent,
              you may contact us to request the removal of your data.
            </p>

            <hr className="privacy-divider" />

            <h2 className="privacy-section-title">7. User Control &amp; Deletion</h2>

            <p>You may:</p>

            <ul className="privacy-list">
              <li>Revoke access via your Google Account permissions</li>
              <li>Contact us to request deletion of your personal information from our servers</li>
            </ul>

            <p>Please email contact at hq.emailajent.com. for any data deletion requests.</p>

            <hr className="privacy-divider" />

            <h2 className="privacy-section-title">8. Changes to This Privacy Policy</h2>

            <p>
              We may update this policy from time to time. If we make significant changes, we will
              notify you via email or a notice on the site.
            </p>

            <hr className="privacy-divider" />

            <h2 className="privacy-section-title">9. Contact Us</h2>

            <p>If you have questions about this policy, contact us at:</p>

            <p>
              <strong>Email:</strong> contact at hq.emailajent.com.
              <br />
              <strong>Website:</strong> https://www.emailajent.com
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default PrivacyPage;
